import { AuthGuard } from "../../../auth/helpers";
import { IRoute } from "app/auth/models/utils-interfaces";
import { RecruitmentStatsComponent } from "./pages/recruitment-stats/recruitment-stats.component";
import CommercialStatsComponent from "./pages/commercial-stats/commercial-stats.component";

const statsRoutes: IRoute[] = [
  {
    path: "dashboard/recruitment/stats",
    component: RecruitmentStatsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/commercial/stats",
    component: CommercialStatsComponent,
    canActivate: [AuthGuard],
  }
];
export default statsRoutes;
